import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { PageTitleConfig } from '../analytics/analytics-router.service';

@Injectable({
  providedIn: 'root',
})
export class TitleConfigService {
  private pageTitles: PageTitleConfig[] = [];

  constructor(
    private router: Router,
    private title: Title,
    private http: HttpClient,
    private translateService: TranslateService,
  ) {}

  public async load(url: string) {
    const pageTitles = await this.http
      .get<PageTitleConfig[]>('assets/page-titles.json')
      .toPromise();

    this.pageTitles = pageTitles;

    this.updateTitle(url);
  }

  private updateTitle(url: string): void {
    const route = this.normalizeRoute(url);
    const pageTitle = this.pageTitles.find(
      (item) => this.normalizeRoute(item.route) === route,
    );

    this.title.setTitle(
      pageTitle?.title || this.translateService.instant('DigitalServicesHub'),
    );
  }

  public getCurrentTitle(): string {
    return this.title.getTitle();
  }

  private normalizeRoute(url: string): string {
    const path = url.split(/[?#]/, 1)[0].replace(/\/+$/, '');
    return path.toLowerCase() || '/';
  }
}
